import { DropdownMenu as DropdownMenuPrimitive } from "radix-ui";
import type { ComponentProps } from "react";

import { cn } from "@/shared/lib";

import {
  type DropdownMenuItemVariantProps,
  dropdownMenuItemVariants,
} from "./dropdownMenuItemVariants";

type DropdownMenuItemProps = ComponentProps<typeof DropdownMenuPrimitive.Item> &
  DropdownMenuItemVariantProps;

export const DropdownMenuItem = ({ className, variant, ...props }: DropdownMenuItemProps) => (
  <DropdownMenuPrimitive.Item
    data-slot="dropdown-menu-item"
    className={cn(dropdownMenuItemVariants({ variant, className }))}
    {...props}
  />
);
